import { SdfAvatar } from '@waypoint/react-components';

const StyledAvatar = ({ src = '', alt = '', ...props }) => {
  return <SdfAvatar shape="rounded" src={src} alt={alt} {...props} />;
};

export default StyledAvatar;
